//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'InputField',
  props: {
    value: String,
    label: String,
    name: String,
    rows: String,
    max: false,
    count: false,
    error: '',
  },
  methods: {
    updateValue: function (value) {
      this.$emit('input', value);
    },
  },
}



// WEBPACK FOOTER //
// ./scripts/vue/fields/TextField.vue